import { c as _c } from "react/compiler-runtime";
import type { FC, PropsWithChildren } from "react";
import { WarningText } from "../../text";
import { FormGroupWrapper, InputLabel } from "./styles";
import type { FormGroupProps } from "./FormGroup.d";
export const FormGroup: FC<PropsWithChildren<FormGroupProps>> = t0 => {
  const $ = _c(11);
  const {
    children,
    label,
    error,
    required: t1,
    containerClassName: className,
    "data-testid": dataId
  } = t0;
  const required = t1 === undefined ? false : t1;
  let t2;
  if ($[0] !== label || $[1] !== required) {
    t2 = <InputLabel $required={required}>{label}</InputLabel>;
    $[0] = label;
    $[1] = required;
    $[2] = t2;
  } else {
    t2 = $[2];
  }
  let t3;
  if ($[3] !== dataId || $[4] !== error) {
    t3 = error && <WarningText data-testid={dataId}>{error}</WarningText>;
    $[3] = dataId;
    $[4] = error;
    $[5] = t3;
  } else {
    t3 = $[5];
  }
  let t4;
  if ($[6] !== children || $[7] !== className || $[8] !== t2 || $[9] !== t3) {
    t4 = <FormGroupWrapper className={className}>{t2}{children}{t3}</FormGroupWrapper>;
    $[6] = children;
    $[7] = className;
    $[8] = t2;
    $[9] = t3;
    $[10] = t4;
  } else {
    t4 = $[10];
  }
  return t4;
};
export default FormGroup;